<div  id="containerFoto" class="container">
    <img class="background-foto" src="../../../assets/images/5_Itinerari-esperienze/5f_Itinerari-didattici_Nave-Sila.jpg">
<div class="content">
    <h1>Calabria</h1>
    <h3>Itinerari didattici</h3>
</div>
</div>
<br>
<div class="breadcrumb">
    <p><a>Esperienze e itinerari</a> > <a class="active">Itinerari didattici</a></p>
</div>
<br>
<div id="fixed-element" [ngClass]="[isFixed ? 'fixed': 'notFixed']">
    <app-sidenav></app-sidenav>
</div>
<div style="text-align: center; margin-top: 30px;">
    <div class="textCenter">
        <p>
            I percorsi dedicati alla conoscenza del paesaggio, della storia e della cultura della Calabria rappresentano il cuore dell’offerta turistica riservata alle Scuole.
            Si tratta di una proposta strutturata rivolta principalmente all’educazione ambientale e alla conoscenza dei processi di interazione tra l’uomo e il paesaggio con particolare riferimento al mondo della produzione agroalimentare.
            <br>
            <br>
            I percorsi didattici, pensati e realizzati dalle Guide Naturalistiche ed Escursionistiche dei Parchi, che da anni si occupano di educazione ambientale, riguardano:
            <br>
            •	gli habitat dei Parchi nazionali e delle Riserve regionali (i parchi nazionali del Pollino, della Sila e dell’Aspromonte, le riserve del Lago di Tarsia-Foce Crati, di Valli Cupe e delle Serre)
            <br>
            •	le fattorie didattiche e le aziende dove si realizzano attività agricole compatibili con gli ecosistemi presenti, in grado di produrre alimenti di qualità
            <br>
            •	I laboratori di creatività sul tema dell’arte e del paesaggio che interessano le Aree protette e i Parchi ludico-educativi diffusi sul territorio calabrese.
            
        </p>
    </div>
</div>
<!-- <br>
<br>
<div class="divider">

</div>
<br>
<br>
<div class="row bannerPollino">
    <div class="col-8">
        <h1 class="banner-header">ESPERIENZE E ITINERARI</h1>
        <br>
        <p>Scegli fra le tante idee di viaggio e proposte di itinerari tematici<br />per conoscere il Parco nazionale dell’Aspromonte.</p>
    </div>
    <div class="col-1">
        <img style="width: 65%;" src="../../../assets/images/logo-parco-top2.png">
    </div>
</div>
<br>
<br>
<div class="home-card">
    <div class="row">
        <div class="col-3 one" id="one">
            <div class="card one">
                <div class="card-body">
                    <div class="content-card">
                        <h1>Sulle strade<br />della Ciclovia<br />dei Parchi</h1>
                        <a (click)="goToCiclovia()">Scopri</a>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-3 two" id="two">
            <div class="card two">
                <div class="card-body">
                    <div class="content-card">
                        <h1>Gerace</h1>
                        <a (click)="goToGerace()">Scopri</a>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-3 three" id="three">
            <div class="card three">
                <div class="card-body">
                    <div class="content-card">
                        <h1>Area grecanica</h1>
                        <a (click)="goToAreaGrecanica()">Scopri</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<br>
<br>
<div class="divider">
    
</div> -->
<br>
<br>
<app-mappe-tematiche></app-mappe-tematiche>
<br>
<br>

<div class="noMobileNews">
    <div class="newsletter">
        <div class="row">
            <div class="col">
                <h2>Rimani in contatto con noi <br />
                    iscriviti alla nostra newsletter ></h2>
            </div>
            <div class="col">
                <h3>Entra nella community di Zampino Viaggi!</h3>
                <p>Clicca sul pulsante qui sotto, compila il form e riceverai le nostre<br />
                    novità su proposte, esperienze, eventi e qualche curiosità.</p>  
            </div>
        </div>
        <div class="row">
            <a href="#" class="btn btn-primary signinNewsButton">Scopri</a>
        </div>
    </div>
</div>


<div class="mobileNews">
    <div class="newsletter">
        <div class="row">
            <div class="col">
                <h2>Rimani in contatto con noi<br />iscriviti alla nostra newsletter</h2>
            </div>
        </div>
        <br>
        <div class="row">
            <div class="col-sm-12">
                <h3>Entra nella community di Zampino Viaggi!</h3>
                <br>
                <p>Clicca sul pulsante qui sotto, compila il form e riceverai le nostre<br />novità su proposte, esperienze, eventi e qualche curiosità.</p>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <a href="#" class="btn btn-primary signinNewsButton">Scopri</a>
            </div>
        </div>
    </div>
</div>